"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fastStableStringify = _interopRequireDefault(require("fast-stable-stringify"));

var _getNested = _interopRequireDefault(require("../getNested"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ConnectFeature =
/*#__PURE__*/
function (_Component) {
  _inherits(ConnectFeature, _Component);

  function ConnectFeature(props, context) {
    var _this;

    _classCallCheck(this, ConnectFeature);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConnectFeature).call(this, props, context));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "subscribeToFeature", function (_ref) {
      var queryName = _ref.queryName,
          _ref$args = _ref.args,
          args = _ref$args === void 0 ? {} : _ref$args;
      var _this$context$abCloud = _this.context.abCloudResolver,
          observeFeature = _this$context$abCloud.observeFeature,
          exposureObserver = _this$context$abCloud.exposureObserver;
      _this.subscription = observeFeature({
        queryName: queryName,
        args: args
      }).subscribe({
        next: function next() {
          var feature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _this.setState({
            feature: feature
          });

          var _ref2 = feature._ab || {},
              exposureId = _ref2.exposureId,
              featureId = _ref2.featureId,
              variationId = _ref2.variationId; // if the ref has been attached, then we track this


          if (_this.myRef.current && exposureObserver) {
            // set up the intersection Observer
            _this.unobserve = exposureObserver(_this.myRef.current, {
              exposureId: exposureId,
              featureId: featureId,
              variationId: variationId,
              name: "Friendly Name"
            });
          }
        },
        error: function error(e) {
          if (e.status === 404) {
            _this.setState({
              error: {
                message: "404 - Feature not found",
                status: 404
              }
            });
          }
        }
      });
    });

    _this.subscription;
    _this.state = {
      variationId: "",
      feature: {}
    };
    _this.myRef = _react.default.createRef();
    return _this;
  }

  _createClass(ConnectFeature, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // this check allows the subscribed feature to change when the args change
      // such as by the url changing but the component still being mounted
      if ((0, _fastStableStringify.default)(this.props.args) !== (0, _fastStableStringify.default)(nextProps.args)) {
        this.subscription.unsubscribe();
        this.setState({
          variationId: "",
          feature: {}
        });
        this.subscribeToFeature(nextProps);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.subscribeToFeature(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.subscription.unsubscribe();

      if (this.unobserve) {
        this.unobserve.unobserve();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this; // We can pass in element (as a string) and the Feature wrapper will make itself into whatever
      // is asked for div, span, p, etc. If we do not pass in anything for this prop, then
      // span will be used by default.


      var Element = this.props.element || "span"; // the element wrapper really only needs to be on the realtime, but there may
      // be cases where that is an issue. Or perhaps we can mess with wrapped component?
      // or maybe we should require the WrappedComponent to implement the onContextMenu
      // or such and have it be a noop in prod
      // If class names are present we will concatenate them with the tracking className
      // and use that on our tracking component.

      var className = this.props.className ? this.state.feature ? "".concat(this.props.className, " ").concat((0, _getNested.default)("feature._ab.exposureId", this.state)) : (0, _getNested.default)("feature._ab.exposureId", this.state) : (0, _getNested.default)("feature._ab.exposureId", this.state); // if manualRef ref is set to true then additional props "ref" and "className" will be passed to the child
      // it will then be the responsibility of the child to implement the ref and className to allow for tracking
      // this is an escape hatch for when the default wrapper component causes problems with some DOM rendering/styling
      // for example when working with material-ui Grids

      if (this.props.manualRef) {
        return this.props.children({
          feature: (this.state.feature || {}).assignment,
          error: this.state.error,
          ref: this.myRef,
          //...this.props
          className: className
        });
      } else {
        return _react.default.createElement(Element, {
          className: className,
          style: this.props.style,
          id: this.props.id,
          ref: function ref(el) {
            return _this2.el = el;
          }
        }, this.props.children({
          feature: (this.state.feature || {}).assignment,
          error: this.state.error
        }));
      }
    }
  }]);

  return ConnectFeature;
}(_react.Component);

_defineProperty(ConnectFeature, "contextTypes", {
  abCloudResolver: _propTypes.default.object
});

ConnectFeature.propTypes = {
  queryName: _propTypes.default.string.isRequired,
  args: _propTypes.default.object,
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  element: _propTypes.default.string,
  children: _propTypes.default.func.isRequired,
  id: _propTypes.default.any
};
var _default = ConnectFeature;
exports.default = _default;